import initialstate from '../initialstate';
import {GET_TASKS_WCGWS} from '../../actions/actiontypes';
import {labels} from '../../util/utils';
import {agGridFieldDataSeparator} from '../../util/uiconstants';

export const CellContentType = {
	Account: 'ACCOUNT',
	Assertion: 'ASSERTION',
	Scot: 'SCOT',
	Wcgw: 'WCGW',
	Task: 'TASK',
	Other: 'OTHER'
};

export default function relatedWCGWsReducer(
	state = initialstate.taskWcgws,
	action
) {
	switch (action.type) {
		case GET_TASKS_WCGWS:
			if (action.response) {
				if (action.response.value) {
					action.response.value = formatData(action.response.value);
				} else {
					return {
						data: []
					};
				}
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
			return action.response || state;

		default:
			return state;
	}
}

function formatData(responseData) {
	let result = [];
	let fieldSeparator = agGridFieldDataSeparator;

	if (responseData) {
		let element = {};

		// Iterate accounts
		responseData.forEach((account) => {
			if (account.assertions.length > 0) {
				// Iterate assertions
				account.assertions.forEach((assertion) => {
					let assertionHierarchy = `${account.id}${fieldSeparator}${assertion.id}`;

					element = {
						rowType: CellContentType.Assertion,
						hierarchy: [assertionHierarchy],
						accountId: account.id,
						leafLevel: account.accountName,
						// AssertionBadge badge props
						assertionId: assertion.assertionId,
						assertionName: assertion.assertionName,
						assertionAbbreviation: assertion.assertionAbbreviation,
						accountName: account.accountName,
						craValue: assertion.craValue,
						inherentRiskTypeId: assertion.inherentRiskTypeId,
						controlRiskTypeId: assertion.controlRiskTypeId,
						hasRiskAssociated: assertion.hasRiskAssociated,
						validationStatus: assertion.validationStatus,
						validationMessages: assertion.validationMessages
					};

					result.push(element);

					// Iterate scots:
					if (assertion.scots.length > 0) {
						assertion.scots.forEach((scot) => {
							let scotHierarchy = `${scot.id}`;
							element = {
								rowType: CellContentType.Scot,
								hierarchy: [assertionHierarchy, scotHierarchy],
								scotId: scot.id,
								scotName: scot.scotName,
								leafLevel: scot.scotName
							};

							result.push(element);

							// Iterate wcgws:
							if (scot.wcgWs.length > 0) {
								scot.wcgWs.forEach((wcgw) => {
									let wcgwHierarchy = `${wcgw.id}`;
									element = {
										rowType: CellContentType.Wcgw,
										hierarchy: [
											assertionHierarchy,
											scotHierarchy,
											wcgwHierarchy
										],
										wcgwId: wcgw.id,
										wcgwName: wcgw.wcgwName,
										leafLevel: wcgw.wcgwName
									};

									result.push(element);

									// Iterate tasks:
									if (wcgw.tasks.length > 0) {
										wcgw.tasks.forEach((task) => {
											let taskHierarchy = `${task.id}`;
											element = {
												rowType: CellContentType.Task,
												hierarchy: [
													assertionHierarchy,
													scotHierarchy,
													wcgwHierarchy,
													taskHierarchy
												],
												taskId: task.id,
												taskName: task.taskName,
												leafLevel: task.taskName
											};

											result.push(element);
										});
									}
								});
							} else {
								// No wcgws found...
								result.push({
									hierarchy: [assertionHierarchy, scotHierarchy, 0],
									leafLevel: labels.noWcgwsIdentified
								});
							}
						});
					} else {
						// No scots found...
						result.push({
							hierarchy: [assertionHierarchy, 0],
							leafLevel: labels.noWcgwsIdentified
						});
					}
				});
			}
		});
	}

	// Formatted array
	return result;
}
